import { getLockDateWarningText } from 'modules/common/selectors/requestSelectors.QBooks';
import { FC, memo, useMemo } from 'react';

import FieldsSection from '../../../components/FieldsSection';
import { messages } from './QBooksSalesInvoiceFields.messages';
import { QBooksSalesInvoiceFieldsProps } from './QBooksSalesInvoiceFields.types';

export const QBooksSalesInvoiceFields: FC<QBooksSalesInvoiceFieldsProps> = memo((props) => {
    const { request } = props;

    const { details } = request;

    const lockDateWarningText = getLockDateWarningText(request);

    const customFields = useMemo(
        () => details.customFields.filter(({ value }) => Boolean(value)),
        [details.customFields]
    );

    return (
        <FieldsSection>
            <FieldsSection.Field
                title={messages.invoiceNumberFieldTitle}
                value={details.number || messages.emptyInvoiceNumber}
            />

            <FieldsSection.Field title={messages.termsFieldTitle} value={details.term?.text} />

            <FieldsSection.Field
                title={messages.dateFieldTitle}
                valueType={FieldsSection.Field.ValueType.Date}
                value={details.date}
                warningText={lockDateWarningText}
            />

            <FieldsSection.Field
                title={messages.dueDateFieldTitle}
                valueType={FieldsSection.Field.ValueType.Date}
                value={details.dueDate}
            />

            <FieldsSection.Field title={messages.billingAddressDateFieldTitle} value={details.billingAddress} />

            {customFields.map(({ field, value }) => (
                <FieldsSection.Field key={field.id} title={field.text} value={value} />
            ))}

            {details.departmentTerminology && details.department && (
                <FieldsSection.Field title={details.departmentTerminology} value={details.department} />
            )}
        </FieldsSection>
    );
});

QBooksSalesInvoiceFields.displayName = 'QBooksSalesInvoiceFields';
